import { PeriodKey } from './../../helpers/formatDate';
import yup, { object, ObjectSchema, mixed } from 'yup';
import periodTypes from 'maps/period-types';
import supportsOneOf from 'helpers/supportsOneOf';

const periodTypeKeys = Object.keys(periodTypes);

const discoveryTrendSchema = object({
  selectedInterval: mixed<PeriodKey>().required().default('day'),
});

export type DiscoveryTrends = yup.InferType<typeof discoveryTrendSchema>;

/**
 * @returns {method} A yup schema to be used for validation
 */
export const getSchema = (): ObjectSchema<DiscoveryTrends> => {
  if (supportsOneOf()) {
    discoveryTrendSchema.fields.selectedInterval = discoveryTrendSchema.fields.selectedInterval.concat(
      mixed<PeriodKey>().oneOf(periodTypeKeys)
    );
  }

  return discoveryTrendSchema;
};
